import React, { createContext, useEffect } from "react";

import useAllWhatsApps from "../../hooks/useAllWhatsApps";
import { useGlobalRegisters } from "../GlobalRegisters/GlobalRegistersContext";

const WhatsAppsContext = createContext();

const WhatsAppsProvider = ({ children }) => {
	const { isLoading: loading, whatsApps } = useAllWhatsApps();
	const { updateAllWhatsapps } = useGlobalRegisters();

	useEffect(() => {
		updateAllWhatsapps()
			.catch(exception => console.log("Exception caught in WhatsAppsProvider while updateingAllWhatsapps. Exception:", exception))

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<WhatsAppsContext.Provider value={{ whatsApps, loading }}>
			{children}
		</WhatsAppsContext.Provider>
	);
};

export { WhatsAppsContext, WhatsAppsProvider };
